<template>
    <div class="history-dequeue__item">
        <div class="d-flex">
            <div>
                <img src="../../assets/avatar/profile.jpg" class="history__dequeue-image">
            </div>
            <div class="flex-grow-1">
                <div class="history-dequeue-name">
                    {{ getName }} <span class="history-dequeue__number">{{ item.number }}</span>
                </div>
                <div class="history-dequeue-desc">
                    <b>Student Number: </b>{{ getStudentNumber }} <br>
                    <b>Western Email: </b>{{ getEmail }}
                </div>
            </div>
            <div>
                <b-button v-b-modal="item.username" class="btn btn-sm btn-primary"><i class="far fa-ellipsis-h"></i>
                </b-button>
            </div>
        </div>
        <b-modal :id="item.username" ok-only centered button-size="sm" ok-title="Close" title="Completed Queue Information">
            <div class="d-flex">
                <div>
                    <img src="../../assets/avatar/profile.jpg" class="history__dequeue-profile">
                </div>
                <div class="flex-grow-1">
                    <div class="history__dequeue-profile--name">
                        {{ getName }} <span class="history__dequeue-profile--number">{{ item.number }}</span>
                    </div>
                    <div class="history__dequeue-profile--desc">
                        <b>Student Number: </b>{{ getStudentNumber }} <br>
                        <b>Western Email: </b>{{ getEmail }}
                    </div>
                </div>
            </div>
            <div class="history-dequeue__item-desc">
                <div class="row mb-1">
                    <div class="col-5 history-dequeue-label">
                        Check-in
                    </div>
                    <div class="col-7 history-dequeue-info">
                        {{ getCheckIn }}
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-5 history-dequeue-label">
                        Counsellor
                    </div>
                    <div class="col-7 history-dequeue-info">
                        {{ getCounsellor }}
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-5 history-dequeue-label">
                        Program
                    </div>
                    <div class="col-7 history-dequeue-info">
                        {{ getProgram }}
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-5 history-dequeue-label">
                        Reason for visit (Notes)
                    </div>
                    <div class="col-7 history-dequeue-info">
                        {{ getNotes }}
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-5 history-dequeue-label">
                        Waiting Area
                    </div>
                    <div class="col-7 history-dequeue-info">
                        {{ getWaitingArea }}
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'history-dequeue-item',
    props: {
        counsellors: {
            type: Array,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        getCheckIn() {
            let date = new  Date(this.item.timestampCheckin * 1000); 
            return `${date.toDateString()}, ${date.toLocaleTimeString()}`;
        },
        getCounsellor() {
            const assignedCounsellor = this.item.counsellor;
            let counsellor;

            // Find counsellor
            if (assignedCounsellor) {
                counsellor = this.counsellors.find(function (counsellor) {
                    return counsellor.username.match(assignedCounsellor);
                });

                if (counsellor && counsellor.commonName) {
                    return counsellor.commonName;
                }
            }

            return 'Not assigned';
        },
        getEmail() {
            return this.item.emailid || "N/A";
        },
        getName() {
            return this.item.name || "N/A";
        },
        getNotes() {
            return this.item.notes || "No description";
        },
        getProgram() {
            return this.item.program || "Not specified";
        },
        getStudentNumber() {
            return this.item.emplid || "N/A";
        },
        getWaitingArea() {
            return this.item.waitingArea || "N/A";
        }
    }
}
</script>

<style scoped>
.history-dequeue__item-desc {
    font-size: 12px;
    margin-top: 1rem;
}

.history-dequeue-desc {
    font-size: 12px;
    margin: 0;
    color: #74788d;
}

.history__dequeue-image {
    float: left;
    border-radius: 4px;
    margin-right: 1rem;
    height: 48px;
    width: 48px;
    -o-object-fit: cover;
    object-fit: cover;
}

.history-dequeue-info {
    color: #74788d;
    font-weight: 500;
    text-align: right;
}

.history-dequeue-label {
    color: #48465b;
    font-weight: 600;
}

.history-dequeue-name {
    font-weight: 700;
    font-size: 14px;
    color: #48465b;
    -webkit-transition: color .3s ease;
    transition: color .3s ease;
}

.history-dequeue__number {
    color: #fd397a;
    font-weight: 600;
}

.history__dequeue-profile {
    float: left;
    border-radius: 4px;
    margin-right: 1rem;
    height: 96px;
    width: 96px;
    -o-object-fit: cover;
    object-fit: cover;
}

.history__dequeue-profile--desc {
    font-size: 14px;
    margin: 0;
    color: #74788d;
}

.history__dequeue-profile--name {
    font-weight: 700;
    font-size: 16px;
    color: #48465b;
    -webkit-transition: color .3s ease;
    transition: color .3s ease;
}

.history__dequeue-profile--number {
    color: #fd397a;
    font-weight: 600;
}
</style>